import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TZyomuinKoteihiListGetReq,
  TZyomuinKoteihiListGetRes,
} from "./TZyomuinKoteihi"

/**
 * 乗務員固定費取得に対するAPIリクエスト用サービス
 *
 * @export
 * @class ZyomuinKyuyoService
 * @extends {ConnectApi}
 */
export default class ZyomuinKoteihiService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TZyomuinKyuyoListGetReq} params
   * @memberof ZyomuinKyuyoService
   */
  getList = async (params: TZyomuinKoteihiListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinKoteihiListGetRes>> =
        await this.getInner(`driverpayroll/koteihi/list`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
